import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { InvoiceIndividualSearchModel } from 'src/app/core/models/individual-model/invoice-individual-search.model';
import { InvoiceOrganisationSearchModel } from 'src/app/core/models/organisation-model';
import { PaymentDocumentInvoiceConstant } from './shared/payment-document-invoice.constants';
import { IndividualDocumentInvoiceComponent } from './individual-document-invoice/individual-document-invoice.component';
import { OrganisationDocumentInvoiceComponent } from './organisation-document-invoice/organisation-document-invoice.component';
import { OrderJsonModel } from 'src/app/core/models/order-model/order-json';
import { PaymentAddressView } from 'src/app/core/models/payment-models/payment-address.model';

@Component({
    selector: 'op-payment-document-invoice',
    templateUrl: './payment-document-invoice.component.html',
})
export class PaymentDocumentInvoiceComponent implements AfterViewInit {

    @Input() invoiceReceiverType: string;
    @Input("orderData") orderData: OrderJsonModel;
    @Output() individualSelected = new EventEmitter<InvoiceIndividualSearchModel>();
    @Output() organisationSelected = new EventEmitter<InvoiceOrganisationSearchModel>();

    @ViewChild(IndividualDocumentInvoiceComponent) individualComponent: IndividualDocumentInvoiceComponent;
    @ViewChild(OrganisationDocumentInvoiceComponent) organisationComponent: OrganisationDocumentInvoiceComponent;

    constructor(private changeDetectorRef: ChangeDetectorRef) {
    }

    get displayIndividual(): boolean {
        return this.invoiceReceiverType === PaymentDocumentInvoiceConstant.INDIVIDUAL_RECEIVER;
    }

    get displayOrganisation(): boolean {
        return this.invoiceReceiverType === PaymentDocumentInvoiceConstant.ORGANISATION_RECEIVER;
    }

    public addressPaymentRequired: boolean = true;

    ngAfterViewInit(): void {
        if (!this.displayOrganisation || !this.orderData) {
            this.individualComponent?.setOrderContact(this.orderData);
        }
    }

    onIndividualSelected(individual: InvoiceIndividualSearchModel) {
        this.individualSelected.emit(individual);
    }

    onOrganisationSeleted(organisation: InvoiceOrganisationSearchModel) {
        this.organisationSelected.emit(organisation);
    }

    public validateIndividualPayment(): boolean {
        return this.individualComponent?.validatePaymentIndividual();
    }

    public validateIndividualPaymentAddress(paymentAddressRequired: boolean): boolean {
        if (paymentAddressRequired) {
            return this.individualComponent?.validatePaymentAddress();
        }
        return true;
    }

    public getPaymentAddress(): PaymentAddressView {
        return this.individualComponent?.getPaymenAddress();
    }

    public getErrorMessagePaymentAddress(): string {
        return this.individualComponent?.getErrorMessagePaymentAddress();
    }
    
    public setAddressPaymentRequired(addressPaymentRequired: boolean) {
        this.addressPaymentRequired = addressPaymentRequired;
        this.changeDetectorRef.detectChanges();
    }

    public clear() {
        this.individualComponent.onClearIndividual();
    }
}
